import { render } from "./TasasPatrimonio.vue?vue&type=template&id=2234f900&scoped=true"
import script from "./TasasPatrimonio.vue?vue&type=script&lang=js"
export * from "./TasasPatrimonio.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./TasasPatrimonio.vue?vue&type=style&index=1&id=2234f900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2234f900"]])

export default __exports__